import { Box, Stack, Typography } from "@mui/material";
import { ReactNode } from "react";
import { colorSubText } from "../../../theme";
interface VeiculoInfoItem {
  icon: ReactNode;
  label: string;
}

interface VeiculoInfoCardProps {
  titulo: string;
  itens: VeiculoInfoItem[];
}



export function VeiculoInfoCard({
  titulo,
  itens,
}: VeiculoInfoCardProps) {
  return (
    <Box width="100%" minHeight={0} mt={2}>
      <Box
        sx={{
          bgcolor: "background.paper",
          py: 1,
          px:1,
          borderRadius: 3,
          boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
          border: "1px solid",
          borderColor: "divider",
        }}
      >
        {/* Título */}
        <Stack direction="row" alignItems="center" spacing={1} mb={2} width={"100%"}>
          {/* Círculo decorativo */}
          <Box
            sx={{
              width:8,
              height: 8,
              borderRadius: "50%",
              bgcolor: "primary.main",
            }}
          />

          <Typography fontWeight={800} fontSize="0.85rem">
            {titulo}
          </Typography>
        </Stack>

        {/* Infos */}
        <Box
          display="grid"
          gridTemplateColumns="repeat(2, 1fr)"
          gap={1}
        >
          {itens.map((item, index) => (
            <Stack
              key={index}
              direction="row"
              spacing={0.2}
              alignItems="center"
            >
              {item.icon}

              <Typography
                fontWeight={500}
                color={colorSubText}
                fontSize="0.75rem"
              >
                {item.label}
              </Typography>
            </Stack>
          ))}
        </Box>
      </Box>
    </Box>
  );
}
